import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";

interface ReactivateUserModalProps {
  isOpen: boolean;
  isReactivating: boolean;
  userName: string;
  onClose: () => void;
  handleReactivate: () => void;
}

const ReactivateUserModal: React.FC<ReactivateUserModalProps> = ({
  isOpen,
  onClose,
  isReactivating,
  userName,
  handleReactivate,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">Reactivate User</h3>
      <p className="mt-3 text-sm text-gray-600">
        Are you sure you want to reactivate <strong>{userName}</strong>?
        <br />
        This restores access to Hub+.
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <Button onClick={onClose} variant="plain">
          Cancel
        </Button>

        <Button
          disabled={isReactivating}
          onClick={() => handleReactivate()}
          variant="default"
        >
          {isReactivating ? "Reactivating..." : "Reactivate User"}
        </Button>
      </div>
    </Modal>
  );
};

export default ReactivateUserModal;
